import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/LandingPricing.css';

export default function LandingPricing() {
    return (
        <div className="LandingPricing">
            <div className="blurb">
                <h3>INSTANTLY GROW YOUR DEPOP</h3>
                <h2>Get Salewave</h2>
                <p>Choose our monthly or annual subscription to get started with Salewave.</p>
            </div>
            <ul className="prices">
                <li>
                    <h3>MONTHLY</h3>
                    <h2>$11/month</h2>
                    <ul>
                        <li>Access to all features</li>
                        <li>Cancel anytime</li>
                        <li>24/7 support</li>
                    </ul>
                    <Link to='/register'>Get Access Today!</Link>
                </li>
                <li>
                    <h3>ANNUAL (SAVE $33)</h3>
                    <h2>$99/year</h2>
                    <ul>
                        <li>Access to all features</li>
                        <li>Cancel anytime</li> 
                        <li>24/7 support</li>
                    </ul>
                    <Link to='/register'>Get Access Today!</Link>
                </li>
            </ul>
        </div>
    )
}